var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lostpassword-page"},[_c('TopBarUnLogin'),_c('LostPasswordPage'),_c('FooterBarWhite')],1)}
var staticRenderFns = []

export { render, staticRenderFns }